import scope from "./scope";
import { exchange } from "@ls/js-fetch";
import Mode from "state/selections/Mode";
import { getAppServerProxy  } from '@ls/in2-url-mapper'
export const REQUEST_TRADE_HISTORY_DATA = `${scope}/REQUEST_TRADE_HISTORY_DATA`;
export const RECEIVE_TRADE_HISTORY_DATA = `${scope}/RECEIVE_TRADE_HISTORY_DATA`;

export const requestTradeHistoryData = (dataFromStore) => {
  return async (dispatch) => {
    dispatch(makeTradeHistoryRequest(dataFromStore));
  };
};

const makeTradeHistoryRequest = (unCommitedData) => {
  const {
    groupType,
    groups,
    asOfDate,
    asOfDateStart,
    entityIds,
    mode,
   // majorMinor,
    replaceMajorsWithMinors,
    showRealizedGl,
    localCurrencyCodes,
    offeringMarkets,
    transactionCodes,
    transactionEffects,
    tickers,
    isShowCanceledTrades,
    betaIds,
    covar,
    holdings,
    securityIds,
    instrumentTypes,
    instrumentTypesIncludeOption,
    absMsaaSectors,
    msaaBucketCodes,
    traderIds
  } = unCommitedData;
  return async (dispatch) => {
    dispatch({
      type: REQUEST_TRADE_HISTORY_DATA,
    });
    const params = {
      identifiers:
        mode === Mode.ENTITIES ? (entityIds === null ? "" : entityIds) : groups,
      groupType:
        mode === Mode.ENTITIES
          ? "groups,composite,entity_list"
          : groupType?.toLowerCase() ?? null,
      startDate: asOfDateStart,
      endDate: asOfDate,
      majorMinorAdjustment: replaceMajorsWithMinors ? "MINOR" : "BOTH",
      showRealizedGl: showRealizedGl,
      localCurrencyCodes: localCurrencyCodes === null ? "" : localCurrencyCodes,
      offeringMarkets: offeringMarkets ?? "",
      orderTypes: transactionCodes === null ? "" : transactionCodes,
      //transactionEffects: transactionEffects === null ? "" : transactionEffects,
      transactionEffects: transactionEffects ?? "",
      tickers: tickers === null ? "" : tickers,
      isShowCanceledTrades: isShowCanceledTrades,
      betaIds: betaIds,
      covar: covar,
      holdings: holdings,
      instrumentTypes: instrumentTypes ?? "",
      instrumentTypesIncludeOption: instrumentTypesIncludeOption ?? "",
      absMsaaSectors: absMsaaSectors ?? "",
      msaaBucketCodes: msaaBucketCodes ?? "",
      repSecIds: securityIds ?? "",
      traderIds: traderIds ?? "",
      appServerProxy: getAppServerProxy() ?? ""
    };

    const responseData = (
      await exchange({
        params,
        baseURL: process.env.REACT_APP_BASE_TRADE_URL,
        url: `rest/tradeHistory`,
        cancelId: `trade-history-data`,
        // dontSendBearerToken : true
      })
    )?.data;

    dispatch({
      type: RECEIVE_TRADE_HISTORY_DATA,
      data: typeof responseData === 'object' && !Array.isArray(responseData) ? [] : responseData,
    });
  };
};
